// sessionStorage: survives the IdP logout round trip in the same tab, and nothing else.
const STORAGE_KEY = 'formshive-account-deleted';

export function markAccountDeleted(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // storage unavailable: no notice
  }
}

/** True once after `markAccountDeleted`. */
export function takeAccountDeletedNotice(): boolean {
  try {
    const marked = sessionStorage.getItem(STORAGE_KEY) === '1';
    sessionStorage.removeItem(STORAGE_KEY);
    return marked;
  } catch {
    return false;
  }
}
